import { render, staticRenderFns } from "./cardConsume.vue?vue&type=template&id=28380dc2&scoped=true"
import script from "./cardConsume.vue?vue&type=script&lang=js"
export * from "./cardConsume.vue?vue&type=script&lang=js"
import style0 from "./cardConsume.vue?vue&type=style&index=0&id=28380dc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28380dc2",
  null
  
)

export default component.exports